<picker
    #picker
    (change)="onStartTimeChange($event)"
    [pickerType]="PickerType.Date"
    [defaultType]="ViewType.Numpad"
></picker>
<header
    title="{{
        this.type === 'checkInUser'
            ? ('CHECK_IN_ALERT.HEADER' | translate)
            : ('CHECK_OUT_ALERT.HEADER' | translate)
    }}"
    backArrow="true"
    (click)="closeModal()"
></header>
<ion-content [forceOverscroll]="false" color="light" [fullscreen]="true">
    <app-loading #loading></app-loading>

    <img src="{{ mapUrl }}" alt="g-maps" />
    <ng-container *ngIf="checkAtSpecificTime">
        <div class="description-note" *ngIf="this.type === 'checkOutUser'">
            <ion-note>{{ "PROJECT_DETAILS.CHECKED_AT" | translate }} {{ checkedAt }}</ion-note>
        </div>
        <ng-container *ngIf="!futureCheckIn">
            <ion-item class="margin-top-10" lines="none">
                <ion-input
                    [label]="
                        this.type === 'checkInUser'
                            ? ('CHECK_IN_ALERT.HEADER' | translate)
                            : ('CHECK_OUT_ALERT.HEADER' | translate)
                    "
                    (click)="openPicker()"
                    [readonly]="true"
                    class="ion-text-end"
                    value="{{ this.time }}"
                ></ion-input>
            </ion-item>
            <div class="description-note">
                <ion-note>{{
                    this.type === "checkInUser"
                        ? ("PROJECT_DETAILS.CHECK_IN_INFO" | translate)
                        : ("PROJECT_DETAILS.CHECK_OUT_INFO" | translate)
                }}</ion-note>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!futureCheckIn">
        <ion-item
            (click)="checkInOut()"
            lines="full"
            [detail]="true"
            class="ion-text-center submit-btn"
            mode="md"
        >
            <ion-label>{{ "SHARED.OK" | translate }}</ion-label>
        </ion-item>
    </ng-container>

    <ng-container *ngIf="futureCheckIn">
        <ion-item
            (click)="delete()"
            lines="full"
            [detail]="true"
            class="ion-text-center delete-btn"
            mode="md"
        >
            <ion-label>{{ "SHARED.CANCEL" | translate }}</ion-label>
        </ion-item>
    </ng-container>
</ion-content>
